import { Fragment } from "react";
import { GiftFill, PrinterFill } from "react-bootstrap-icons";

const ServiceInPlaceIcons = ({ shipment }) => {
  return (
    <div className="d-flex flex-wrap justify-content-center column-gap-2">
      {shipment.Packaging > 0 && (
        <Fragment>
          <GiftFill color="orange" title="نیازمند بسته بندی" />
          <PrinterFill color="#4B1483" title="نیازمند فاکتور" />
        </Fragment>
      )}

      {shipment.Packaging === 0 && shipment.printFactor > 0 && (
        <PrinterFill color="#4B1483" title="نیازمند فاکتور" />
      )}
    </div>
  );
};
export default ServiceInPlaceIcons;
